import { ButtonHTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';
import { Spinner } from '../Spinner';

type ButtonVariant = 'primary' | 'outlined' | 'text';
type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: ReactNode;
  isLoading?: boolean;
}

export const Button = ({
  variant = 'primary',
  size = 'md',
  className,
  children,
  isLoading,
  disabled,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center gap-2 rounded-button font-normal transition-colors disabled:cursor-not-allowed disabled:opacity-50',
        {
          'bg-gold text-white hover:bg-gold-dark': variant === 'primary',
          'border border-gold bg-transparent text-gold hover:bg-gold-light':
            variant === 'outlined',
          'text-gold hover:bg-gold-light': variant === 'text',
          'px-4 py-1.5 text-s': size === 'sm',
          'px-7 py-2 text-m': size === 'md',
          'px-8 py-3 text-l': size === 'lg',
        },
        className
      )}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? <Spinner size="sm" /> : children}
    </button>
  );
};
